<main class="container-fluid">
  <article class="row row bg-white shadow mb-3 mt-3 ml-0 mr-0">
    <section class="col-3 border-right p-4 mt-5 mb-5">
      <header class="text-center mb-3">
        <label class="h5">Sanciones</label>
      </header>
      <form [formGroup]="formDatos" (ngSubmit)="getRnt()">
        <div class="form-group">
          <label class="small text-secondary" for="nit"
            >Ingrese el número de RNT</label
          >
          <input
            type="text"
            id="codigo_rnt"
            formControlName="codigo_rnt"
            class="form-control form-control-sm"
          />
        </div>
        <div class="form-row mt-5">
          <button
            class="btn btn-primary m-auto"
            [disabled]="!formDatos.valid"
            type="submit"
          >
            Buscar
          </button>
        </div>
      </form>
    </section>
    <section class="col-9 p-4 mt-5 mb-5" *ngIf="datosRnt; else no_data">
      <section class="row mb-4 border-bottom pl-2">
        <section class="col-12 mb-4 border-bottom">
          <footer class="row">
            <h2 class="col-9 mt-4 h5 font-weight-bold mb-2">
              Datos del prestador
            </h2>
            <div class="col-3 text-right">
              <ng-container *ngIf="sancionesActuales; else ''">
                <img
                  width="35px"
                  height="35px"
                  src="../../../../../../../assets/icons/Icon_alert.png"
                />
                <label class="small">RNT con sanciones</label>
              </ng-container>
            </div>
            <!-- <ng-container
              *ngIf="
                datoSolicitudSharedModel.tipo_rnt !== tipo_rnt_guia;
                else es_guia
              "
            > -->
            <div class="col-sm-12 col-md-3">
              <label class="small mb-0">Representante legal</label>
              <p>
                <strong>{{ datosRnt.nombre_representante_legal }}</strong>
              </p>
            </div>
            <div class="col-sm-12 col-md-3">
              <label class="small mb-0">Número identificación</label>
              <p>
                <strong>{{
                  datosRnt.numero_identificacion_representante_legal
                }}</strong>
              </p>
            </div>
            <!-- </ng-container> -->
            <!-- <ng-template #es_guia>
              <div class="col-sm-12 col-md-3">
                <label class="small mb-0">Número identificación</label>
                <p>
                  <strong
                    >{{
                    informacionEstablecimiento.numero_identificacion
                    }}</strong
                  >
                </p>
              </div>
            </ng-template> -->
            <div class="col-sm-12 col-md-3">
              <label class="small mb-0">Patrimonio neto</label>
              <p>
                <strong>{{
                  datosRnt.patrimonio_neto | currency: "COP"
                }}</strong>
              </p>
            </div>
            <div class="col-sm-12 col-md-3">
              <label class="small mb-0">Número de empleados</label>
              <p>
                <strong>{{ datosRnt.numero_empleados }}</strong>
              </p>
            </div>
          </footer>
        </section>
        <section class="col-12 mb-4 mt-1 border-bottom">
          <footer class="row">
            <!-- Establecimiento -->
            <!-- <ng-container
              *ngIf="
                datoSolicitudSharedModel.tipo_rnt === tipo_rnt_establecimiento
              "
            > -->
            <h2 class="col-12 h5 font-weight-bold mb-2">
              Datos del establecimiento
            </h2>
            <div class="col-sm-12 col-md-3">
              <label class="small mb-0">Nombre</label>
              <p>
                <strong>{{ datosRnt.nombre_establecimiento }}</strong>
              </p>
            </div>
            <div class="col-sm-12 col-md-3">
              <label class="small mb-0">Matrícula mercantíl</label>
              <p>
                <strong>{{ datosRnt.matricula }}</strong>
              </p>
            </div>
            <div class="col-sm-12 col-md-3">
              <label class="small mb-0">Último año renovado</label>
              <p>
                <strong>{{ datosRnt.ultimo_anio_renovado }}</strong>
              </p>
            </div>
            <!-- </ng-container> -->
            <!-- Inmueble -->
            <!-- <ng-container
              *ngIf="datoSolicitudSharedModel.tipo_rnt === tipo_rnt_inmueble"
            >
              <h2 class="col-12 h5 font-weight-bold mb-2">
                Datos del inmueble
              </h2>
            </ng-container> -->
            <!-- Guia -->
            <!-- <ng-container
              *ngIf="datoSolicitudSharedModel.tipo_rnt === tipo_rnt_guia"
            >
              <h2 class="col-12 h5 font-weight-bold mb-2">Datos del guía</h2>
              <div class="col-sm-12 col-md-3">
                <label class="small mb-0">Nombre de guia</label>
                <p>
                  <strong
                    >{{
                    informacionEstablecimiento.nombre_gerente
                    }}</strong
                  >
                </p>
              </div>
            </ng-container> -->
            <!-- Datos generales -->
            <div class="col-sm-12 col-md-3">
              <label class="small mb-0">Último año renovado RNT</label>
              <p>
                <strong>{{ datosRnt.ultimo_anio_renovado_rnt }}</strong>
              </p>
            </div>
            <div class="col-sm-12 col-md-3">
              <label class="small mb-0">Dirección</label>
              <p>
                <strong>{{ datosRnt.direccion_comercial }}</strong>
              </p>
            </div>
            <div class="col-sm-12 col-md-3">
              <label class="small mb-0">Departamento</label>
              <p>
                <strong>{{ datosRnt.departamento }}</strong>
              </p>
            </div>
            <div class="col-sm-12 col-md-3">
              <label class="small mb-0">Municipio</label>
              <p>
                <strong>{{ datosRnt.municipio }}</strong>
              </p>
            </div>
            <div class="col-sm-12 col-md-3">
              <label class="small mb-0">Cámara de comercio</label>
              <p>
                <strong>{{ datosRnt.camara_de_comercio }}</strong>
              </p>
            </div>
            <div class="col-sm-12 col-md-3">
              <label class="small mb-0">Categoría</label>
              <p>
                <strong>{{ datosRnt.categoria }}</strong>
              </p>
            </div>
            <div class="col-sm-12 col-md-3">
              <label class="small mb-0">Sub categoría</label>
              <p>
                <strong>{{ datosRnt.subcategoria }}</strong>
              </p>
            </div>
            <div class="col-sm-12 col-md-3">
              <label class="small mb-0">Teléfono</label>
              <p>
                <strong>{{ datosRnt.numero_telefonico }}</strong>
              </p>
            </div>
          </footer>
        </section>
        <section class="col-12 mb-4 mt-1">
          <footer class="row">
            <h2 class="col-12 h5 font-weight-bold mb-2">Datos del RNT</h2>
            <div class="col-sm-12 col-md-3">
              <label class="small mb-0">Número de RNT</label>
              <p>
                <strong>{{ cod_rnt }}</strong>
              </p>
            </div>
            <div class="col-sm-12 col-md-3">
              <label class="small mb-0">Estado</label>
              <p>
                <strong>{{ datosRnt.estado_rnt }}</strong>
              </p>
            </div>
            <div class="col-sm-12 col-md-6 centrar-boton">
              <button
                class="btn btn-primary paso-capacidad"
                (click)="openModalAsignarSancion()"
              >
                Asignar Sanción
              </button>
            </div>
          </footer>
        </section>
      </section>
      <section
        class="row mb-2 pl-2"
        *ngIf="sancionesActuales; else no_sanciones"
      >
        <h2 class="col-12 h5 font-weight-bold mb-4">Sanciones actuales</h2>
        <div
          class="col-12 mb-4"
          *ngFor="let item of sancionesActuales; let i = index"
        >
          <div class="card px-0 col-12">
            <div class="col-12">
              <a
                type="button"
                class="text-decoration-none text-dark col-12 px-0 py-2 pointer"
                (click)="item.isCollapsed = !item.isCollapsed"
                [attr.aria-expanded]="!item.isCollapsed"
                [attr.aria-controls]="'informacionCompleta' + item.sancion_id"
              >
                <label class="col-8 mb-0 pointer px-0"
                  >Sanción del
                  {{ item.fecha_inicio_sancion | date: "d/MMM/yyyy" }}</label
                >
                <label
                  *ngIf="!item.isCollapsed"
                  class="col-4 pointer arrow bottom text-right px-0 mb-0"
                ></label>
                <label
                  *ngIf="item.isCollapsed"
                  class="col-4 pointer arrow top text-right px-0 mb-0"
                ></label>
              </a>
            </div>
            <div
              id="informacionCompleta{{ item.sancion_id }}"
              class="row px-3"
              [ngbCollapse]="!item.isCollapsed"
            >
              <div class="col-md-4 col-sm-12">
                <label class="small mb-0">Representante legal</label>
                <p>
                  <strong>{{ item.nombre_representante_legal }}</strong>
                </p>
                <label class="small mb-0">Número de identificación</label>
                <p>
                  <strong>{{
                    item.numero_identificacion_representante_legal
                  }}</strong>
                </p>
                <label class="small mb-0">Patrimonio neto</label>
                <p>
                  <strong>{{ item.patrimonio_neto }}</strong>
                </p>
                <label class="small mb-0">Número de empleados</label>
                <p>
                  <strong>{{ item.numero_empleados }}</strong>
                </p>
                <label class="small mb-0">Razón social</label>
                <p>
                  <strong>{{
                    item.numero_identificacion_representante_legal
                  }}</strong>
                </p>
                <label class="small mb-0">Cámara de comercio</label>
                <p>
                  <strong>{{ item.camara_de_comercio }}</strong>
                </p>
                <label class="small mb-0">Teléfono del establecimiento</label>
                <p>
                  <strong>{{ item.numero_telefonico }}</strong>
                </p>
              </div>
              <div class="col-md-4 col-sm-12">
                <label class="small mb-0">Nombre del establecimiento</label>
                <p>
                  <strong>{{ item.nombre_establecimiento }}</strong>
                </p>
                <label class="small mb-0">Matrícula mercantíl</label>
                <p>
                  <strong>{{ item.matricula }}</strong>
                </p>
                <label class="small mb-0">Último año renovado</label>
                <p>
                  <strong>{{ item.ultimo_anio_renovado }}</strong>
                </p>
                <label class="small mb-0">Estado de RNT</label>
                <p>
                  <strong>{{ item.estado_rnt }}</strong>
                </p>
                <label class="small mb-0">Dirección</label>
                <p>
                  <strong>{{ item.direccion_comercial }}</strong>
                </p>
                <label class="small mb-0">Categoría</label>
                <p>
                  <strong>{{ item.categoria }}</strong>
                </p>
                <label class="small mb-0">Sub categoría</label>
                <p>
                  <strong>{{ item.subcategoria }}</strong>
                </p>
              </div>
              <div class="col-md-4 col-sm-12 mb-3 centrar-boton">
                <button
                  class="btn btn-primary paso-capacidad"
                  (click)="openModalAnularSancion(item)"
                >
                  Anular Sanción
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <ng-template #no_sanciones>
        <label>No tiene sanciones actuales</label>
      </ng-template>
    </section>
    <ng-template #no_data>
      <section class="col-9 p-4 mt-5 mb-5">
        <header class="col-12">
          <figure class="figure w-100 text-center">
            <img
              class="img-fluid mb-4"
              src="../../../../../../../assets/images/sin_establecimiento.png"
            />
            <figcaption>
              <label class="h3">No hay información</label>
            </figcaption>
          </figure>
        </header>
      </section>
    </ng-template>
  </article>
</main>
